import { Stack, Button, CircularProgress, Alert } from "@mui/material";
import Modal, { CommonModalProps } from "..";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import AssetAndChildrenCard from "../../Access/Shared/asset-and-children-card";
import React from "react";
import { accessService, assetService } from "../../../Core/Api/services";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";
export interface ModalRevokeExternalAccessElementProps {
  accessId: number;
  asset: DbAssetObjectInfos;
  onSuccess: () => void;
}

type ModalRevokeExternalAccessProps = CommonModalProps<ModalRevokeExternalAccessElementProps>;

const ModalRevokeExternalAccess = React.forwardRef<any, ModalRevokeExternalAccessProps>((props, ref) => {
  const { t } = useTranslation();
  const { accessId, asset: _asset, onSuccess, closeModal } = props;

  const enqueueSnackbar = useCustomSnackbar();

  const [isWaitingCall, setIsWaitingCall] = React.useState(false);
  const [asset, setAsset] = React.useState(_asset);

  const handleConfirmClick = () => {
    setIsWaitingCall(true);
    accessService
      .RevokeExternalAccess(accessId)
      .then((response) => {
        if (response.success) {
          onSuccess();
          enqueueSnackbar(t("alert:success.externalAccessRevoked"), "success");
          closeModal();
        } else {
          enqueueSnackbar(response.message || t("alert:error.oopsSomethingWentWrongWithoutDot"), "error");
        }
      })
      .finally(() => setIsWaitingCall(false));
  };

  return (
    <Modal
      title={t("modal:title.confirmRevokeOfExternalAccess")}
      reference={ref}
      closeModal={closeModal}
      width={600}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={closeModal}>{t("common:cancel")}</Button>
          <Button variant="contained" onClick={handleConfirmClick}>
            {isWaitingCall ? <CircularProgress size={20} color="secondary" /> : t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={2}>
        <Alert severity="warning">{t("alert:warning.revokeAccessOnAllChildrenConfirmation")}</Alert>
        <AssetAndChildrenCard asset={asset} />
      </Stack>
    </Modal>
  );
});

export default ModalRevokeExternalAccess;
